
export const withoutHours = (date) => (new Date(date)).setHours(0, 0, 0, 0)
